/**
 * Format a client/headline count for public display.
 * Rounds down to the nearest ten and appends "+" once we hit 10,
 * so e.g. 31 → "30+", 6 → "6". Keeps the messaging confident without
 * over-claiming an exact number.
 */
export const formatClientCount = (n) => {
  if (!n || n < 1) return '0';
  if (n < 10) return String(n);
  return `${Math.floor(n / 10) * 10}+`;
};
